export { GlobalNav } from "./nav-global";
export { ProductPageSubNav } from "./nav-product-page";
export { CompoundSubNav } from "./nav-global-compound-subnav";

export { GlobalNav as default } from "./nav-global";
